import { ComponentBase } from '@abstracts/component-base';
import { Component, Injector, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import AnnotationPlugin from 'chartjs-plugin-annotation';

Chart.register(...registerables)

@Component({
  selector: 'energy-distribution-chart',
  templateUrl: './energy-distribution-chart.component.html'
})
export class EnergyDistributionChartComponent extends ComponentBase implements OnInit, OnChanges, OnDestroy {

  public className: string = "EnergyDistributionChart"

  @Input() data: any[]
  @Input() date: Date
  @Input() isLoading: boolean = true
  public availableData: {}[] = []

  public chart: Chart
  public canvas: any
  public ctx: any

  public totalAmount: number
  public max: number
  public min: number
  public average: number
  public maxShow: boolean = false
  public minShow: boolean = false
  public isShowingAverage: boolean = false
  public defaultRange: string

  constructor(
    injector: Injector
  ) {
    super(injector)
  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnChanges() {
    if (!this.data) return

    if (!this.chart) this.createChart()
    else this.chart?.update()

    this.initDatasets()
  }

  ngOnDestroy(): void {
    this.chart?.destroy()
  }

  private initDatasets() {
    this.chart.data.datasets = []

    this.addDataset({
      label: this.data.map(ed => ed.energyMeter.name),
      data: this.data.map(ed => ed.percentageOfTotal),
      backgroundColor: this.data.map(ed => `rgba(${this.getBackgroundColor(ed.energyMeter.energyMeterType.colorCodeInHex)} / .3)`),
      borderColor: this.data.map(ed => `rgb(${this.getBackgroundColor(ed.energyMeter.energyMeterType.colorCodeInHex)})`),
      order: this.data.map(ed => this.getOrder())
    })
  }

  private addDataset(dataset) {
    if (!dataset['cubicInterpolationMode']) dataset['cubicInterpolationMode'] = 'monotone'
    if (!dataset['borderWidth']) dataset['borderWidth'] = 1
    if (!dataset['tension']) dataset['tension'] = 0.5

    dataset['fill'] = true
    dataset['datalabels'] = {}
    dataset['datalabels']['color'] = 'auto'
    dataset['datalabels']['formatter'] = (value) => {
      if (isNaN(value)) return ''
      return `${value.toFixed(2)}%`
    },

      this.chart.data.datasets.push(dataset)
    this.chart?.update()
  }

  private createChart() {
    this.canvas = document.getElementById('energy-distribution-chart-canvas')
    this.ctx = this.canvas.getContext('2d')

    Chart.register(AnnotationPlugin)

    this.chart = new Chart(this.ctx, {
      plugins: [ChartDataLabels],
      type: 'pie',
      data: {
        labels: this.data.map(em => em.energyMeter.name),
        datasets: [],
      },
      options: {
        plugins: {
          legend: {
            labels: {
              color: '#212529',
              font: {
                size: 14,
                family: 'Lato',
              }
            }
          },
          tooltip: {
            enabled: false
          }
        }
      }
    })

    this.isLoading = false
  }

  private getBackgroundColor(hex: string) {
    hex = hex.replace(/^#/, '');
    let bigint = parseInt(hex, 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;

    return `${r} ${g} ${b}`;
  }

  private getOrder() {
    return 1;
  }
}
